/**
 * アプリケーションルーター
 * React Routerの設定とルーティング管理
 */

import { RouterProvider } from 'react-router-dom'
import { router } from './index'

/**
 * アプリケーションルーターコンポーネント
 */
export const AppRouter = () => {
    return <RouterProvider router={router} />
}
